var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRibbon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.39574 10.4156C3.58333 12.6129 5.77243 14.2039 8.36202 14.5928L5.97982 17.0269C5.4615 17.5565 5.20182 17.8215 4.98232 17.9132C4.48201 18.1221 3.92643 17.9434 3.66325 17.4886C3.54787 17.2889 3.51207 16.9288 3.44012 16.2091C3.39949 15.8026 3.37898 15.5994 3.31731 15.4292C3.17927 15.0481 2.88951 14.7515 2.51668 14.6104C2.35007 14.5473 2.15045 14.527 1.75262 14.4855C1.04808 14.4119 0.695431 14.375 0.50011 14.257C0.0552317 13.9881 -0.119371 13.4209 0.0847958 12.9099C0.174502 12.6856 0.433571 12.4201 0.951987 11.8904L2.39574 10.4156Z",
    fill: "url(#paint0_linear_700_1826)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.248 11.8904C18.7664 12.4201 19.0255 12.6856 19.1152 12.9099C19.3194 13.421 19.1448 13.9881 18.6999 14.257C18.5045 14.375 18.152 14.4119 17.4474 14.4855C17.0498 14.527 16.8508 14.5475 16.6842 14.6104C16.3112 14.7515 16.0208 15.048 15.8827 15.4292C15.821 15.5994 15.8005 15.8026 15.7599 16.2091C15.6879 16.9288 15.6521 17.289 15.5367 17.4886C15.2736 17.9434 14.718 18.1221 14.2177 17.9132C13.9982 17.8215 13.7392 17.5564 13.2211 17.0269L10.838 14.5928C13.4276 14.2039 15.6166 12.6129 16.8042 10.4156L18.248 11.8904Z",
    fill: "url(#paint1_linear_700_1826)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60046 0C13.3116 0.000228262 16.3205 2.96924 16.3205 6.63166C16.3205 10.2941 13.3116 13.2631 9.60046 13.2633C5.88909 13.2633 2.88043 10.2942 2.88043 6.63166C2.88043 2.96909 5.88909 0 9.60046 0ZM9.60046 3.78952C9.32777 3.78952 9.14493 4.1124 8.78014 4.75818L8.68546 4.92563C8.58194 5.1089 8.52996 5.20097 8.4492 5.26147C8.36845 5.32183 8.26773 5.34426 8.0667 5.38915L7.88295 5.42986C7.17483 5.58797 6.82064 5.66763 6.73639 5.935C6.65243 6.2023 6.89405 6.48083 7.3767 7.03781L7.50139 7.18214C7.63862 7.34051 7.70771 7.42002 7.73858 7.51798C7.76934 7.61584 7.75836 7.72146 7.73764 7.93246L7.71889 8.12489C7.64588 8.86838 7.6099 9.24004 7.83045 9.40534C8.05105 9.5706 8.38231 9.41985 9.04546 9.11853L9.21702 9.04082C9.4055 8.95518 9.50056 8.91222 9.60046 8.91222C9.7002 8.91234 9.79475 8.9553 9.98296 9.04082L10.1545 9.11853C10.8177 9.41987 11.1489 9.5706 11.3695 9.40534C11.5901 9.24006 11.5541 8.86844 11.4811 8.12489L11.4623 7.93246C11.4416 7.72149 11.4307 7.61583 11.4614 7.51798C11.4923 7.42002 11.5614 7.3405 11.6986 7.18214L11.8233 7.03781C12.306 6.48079 12.5476 6.20231 12.4636 5.935C12.3793 5.66762 12.0252 5.58798 11.317 5.42986L11.1333 5.38915C10.9323 5.34426 10.8315 5.32185 10.7508 5.26147C10.67 5.20097 10.6181 5.10892 10.5145 4.92563L10.4198 4.75818C10.0553 4.11276 9.87291 3.78986 9.60046 3.78952Z",
    fill: "url(#paint2_linear_700_1826)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_700_1826",
    x1: 3.36437,
    y1: 5.01172,
    x2: 19.2505,
    y2: 22.8042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_700_1826",
    x1: 3.36437,
    y1: 5.01172,
    x2: 19.2505,
    y2: 22.8042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_700_1826",
    x1: 3.36437,
    y1: 5.01172,
    x2: 19.2505,
    y2: 22.8042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbon);
export default __webpack_public_path__ + "static/media/Ribbon.7ae2d829a2d26ea7d446f3f45078bf7c.svg";
export { ForwardRef as ReactComponent };